import React, { Component } from 'react'
import { Spin } from '@arco-design/web-react'
import { IconStarFill, IconRight } from '@arco-design/web-react/icon'
import { getconfig } from 'api/apis'
import './index.scss'
// 封装组件
class Billingmethod extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingbody: false,
      data: {
        heads: {
          //头部配置-width：头部对应宽度
          套餐类型: { width: '15%' },
          收费项目: { width: '20%' },
          收费计量: { width: '20%' },
          收费金额: { width: '20%' },
          资费说明: { width: '25%' }
        },
        bodys: []
      }
    }
  }
  componentDidMount() {
    this.gitconfig()
  }
  UNSAFE_componentDidUpdate() {}
  setObject(arr) {
    let newarray = []
    for (let key in arr) {
      newarray.push(key)
    }
    return newarray
  }

  gitconfig() {
    getconfig({ key: 'commercial-rules' }).then((res) => {
      if (res.code === 200) {
        let list = res.data
        let obj = list.value
        const test = {
          heads: {
            产品: {
              width: '10%'
            },
            服务项: {
              width: '25%'
            },
            说明: {
              width: '35%'
            },
            费用: {
              width: '10%'
            },
            资费说明: {
              width: '20%'
            }
          },
          bodys: [
            {
              type: '智能PPT',
              payservice: [
                {
                  title: '生成PPT',
                  function: ['主题/描述生成PPT', '大纲生成PPT'],
                  metering: [
                    '一句话描述生成PPT',
                    '基于给定的大纲结构文本生成PPT'
                  ],
                  moneys: ['0', '0']
                },
                {
                  title: '步骤生成PPT',
                  function: ['生成大纲与标题', '生成PPT预览图', '重新生成PPT'],
                  metering: [
                    '根据描述需求生成大纲与标题内容',
                    '获取生成文档的实时渲染预览图',
                    '基于当前生成PPT进行重新生成PPT（一句话描述）'
                  ],
                  moneys: ['0', '0', '0']
                },
                {
                  title: '导出下载',
                  function: [
                    '下载导出PDF文件',
                    '下载长图文件',
                    '下载导出PPTX文件'
                  ],
                  metering: [
                    '下载导出PDF文件',
                    '下载长图文件',
                    '可编辑的PPTX文件'
                  ],
                  moneys: ['0', '0', '1.5元/份']
                },
                {
                  title: '深度编辑',
                  function: [
                    '新增单页',
                    '全文字体',
                    '全文动画',
                    '更改模版',
                    '更改主题色',
                    '生成备注/演讲稿'
                  ],
                  metering: [
                    '基于指定需求描述生成单页（需要给定task_id）补充生成',
                    '基于当前文档全文更换字体，例如宋体、楷书等',
                    '基于当前文件设置全文PPT动画',
                    '重新更改当前文档风格',
                    '更改当前文件的全文风格颜色',
                    '基于给定的文件生成全文演讲稿'
                  ],
                  moneys: [
                    '0.1元/次',
                    '0.1元/次',
                    '0.1元/次',
                    '0.2元/次',
                    '0.2元/次',
                    '0.1元/次'
                  ]
                },
                {
                  title: '特色文档生成',
                  function: [
                    '通过论文生成PPT（特色生成）',
                    '通过文件生成PPT（特色生成）',
                    '基于网页链接生成'
                  ],
                  metering: [
                    '导出论文文档生成PPT（可以指定风格、学校等主题色）',
                    '基于给定的文件进行生成PPT，支持Word、PDF、脑图等23种文件格式',
                    '基于给定的在线网页链接生成PPT'
                  ],
                  moneys: ['1.5元/次', '0.5元/次', '0.5元/次']
                }
              ],
              moneysMetering: `阶梯式充值：<br/>
                        （1）充值金额<2W，无折扣<br/>
                        （2）2W≤充值金额<5W，享受调用费用八折优惠<br/>
                        （3）5W≤充值金额，享受调用费用六折优惠<br/>
                        （4）免费功能需要账户余额大于 0 方可使用。您可以充值任意金额以激活免费功能的调用权限。`
            },
            {
              type: '智能PPT(Sass版本)',
              payservice: [
                {
                  title: '基础版',
                  function: ['首页', '创作流程', '在线编辑器', '导出下载'],
                  metering: [
                    '主题、导入文件、网页、从AI模板、入参模块生成PPT入口',
                    '主题、导入文件、网页、从AI模板、配图模式、入参模块生成PPT',
                    '基础编辑、基础美化排版、文档展示、创作历史、云端保存',
                    '导出下载PPTX'
                  ],
                  moneys: ['0', '0', '0', '1.5元/次'],
                  discount: `
                                <strong>LOGO</strong>：上传并替换企业专属标识<br/>
                                <strong>主题色系</strong>：自定义全局主色调<br/>
                                <strong>背景图片</strong>：首页背景图片<br/>
                                <strong>开场白</strong>：自定义欢迎语或提示文案<br/>
                            <p>👉 轻松完成品牌化配置，统一企业视觉与交互风格。</p>`
                },
                {
                  title: '基础版',
                  function: [
                    '页面创建',
                    '基础编辑',
                    '动画效果',
                    '插入网页',
                    '文件导出',
                    '幻灯片设置',
                    '演示播放',
                    '上传服务',
                    '导出服务',
                    '美化服务',
                    '排版美化',
                    '资源库',
                    'AI图片',
                    'AI演讲稿',
                    'AI辅写'
                  ],
                  metering: [
                    '新建 PPT 页面、逐页编辑',
                    '文本框、形状、插入图片、表格、图表、视频、音频、公式、添加备注',
                    '基础动画添加',
                    '支持插入已有网页链接，用于嵌入展示',
                    '下载为长图 / PDF',
                    '背景填充、主题颜色设置、全局默认字体配置',
                    '包含画笔工具、倒计时、激光笔等演示功能',
                    '上传已有的PPT',
                    '导出PPTX格式文件',
                    '上传已有的PPT进行全文美化（更换模板）',
                    '单页、全文美化',
                    '图片、音频、视频资源库，插入图片、音频、视频',
                    'AI生成图片替换PPT中原有的图片',
                    'AI生成演讲稿',
                    '续写、扩写、精炼、润色'
                  ],
                  moneys: [
                    '0',
                    '0',
                    '0',
                    '0',
                    '0',
                    '0',
                    '0',
                    '0.3元/份',
                    '0.5元/份',
                    '0.5元/份',
                    '0.2元/页',
                    '0.03元/次',
                    '0.1元/张',
                    '0.1元/张',
                    '0.01元/次'
                  ],
                  discount: `
                               <strong>开源功能</strong>：从零开始逐页制作 PPT，包含完整的基础编辑能力<br/>
                                <strong>核心功能</strong>：在基础编辑之上，提供 AI 辅助、美化增强、资源库和导入导出等能力<br/>
                           `
                },
                {
                  title: '组件版',
                  function: [],
                  metering: [],
                  moneys: [],
                  discount: `待上线`
                }
              ]
            },
            {
              type: '智能简历',
              payservice: [
                {
                  title: '简历生成与美化',
                  function: ['简历生成', '简历美化'],
                  metering: [
                    '基于关键词生成一份内容完整的简历',
                    '基于简历文件更换简历模板'
                  ],
                  moneys: ['0.5元/次', '0.2元/次']
                },
                {
                  title: '简历处理与分析',
                  function: ['简历解析', '简历分析'],
                  metering: [
                    '解析简历文件，将简历内容数据结构化',
                    '评估简历质量，提供优化建议'
                  ],
                  moneys: ['0.1元/次', '0.8元/次']
                },
                {
                  title: '求职辅助与匹配',
                  function: ['人岗匹配', '岗位探测'],
                  metering: [
                    '基于用户简历和岗位JD，智能分析人岗是否匹配',
                    '推送符合用户职业发展规划的岗位信息'
                  ],
                  moneys: ['0.1元/次', '1元/次（10个匹配结果）']
                }
              ],
              moneysMetering: '&nbsp;&nbsp;&nbsp;&nbsp'
            },
            {
              type: '智能营销',
              payservice: [
                {
                  title: '营销文案',
                  function: ['/'],
                  metering: ['基于文案要求，智能生成符合需求的营销文案'],
                  moneys: ['0.05元/千字符']
                }
              ],
              moneysMetering: `费用 = 实际字符数 × 0.00005元`
            },
            {
              type: '智能合同',
              payservice: [
                {
                  title: '合同生成',
                  function: ['/'],
                  metering: ['基于合同要求，智能生成符合需求的合同'],
                  moneys: ['0.3元/次']
                }
              ],
              moneysMetering: ``
            }
          ]
        }

        this.setState({
          data: test
        })
        // this.setheight("th_id00", 2, "th_id000");
      }
    })
  }
  setbackground(color) {
    return color ? color : 'transparent'
  }
  setheight(e, explains_length, explains_id) {
    setTimeout(() => {
      let height = document.getElementById(e)
      if (height) {
        let new_height = height.clientHeight / explains_length + 'px'
        // console.log(new_height, "height.clientHeight", e);
        document.getElementById(explains_id).height = new_height
      }
    }, 10000)
  }
  render() {
    const { loadingbody, data } = this.state
    var widthleft = 0
    return (
      <div className="billing-method">
        {loadingbody ? (
          <Spin loading={loadingbody} dot className="loadingbody"></Spin>
        ) : (
          <>
            <div className="Header-init">
              <div className="Header-title">计费方式</div>
            </div>
            {/* <div className="payment-explain">
              <div className="payment-explain-lable AlibabaPuHuiTi-Medium">
                <IconStarFill />
                使用说明
              </div>
              <div>
                1.系统采用专有权益包、权益包、预充值三种计费模式，以下表格是预充值的计费说明。
                <br />
                2.预充值以接口请求成功次数作为核算口径进行计费，不同的产品，单次请求的价格不同。
              </div>
            </div> */}
            <div className="billing-list">
              <div className="billingBanner">
                <div className="AlibabaPuHuiTi-Medium">
                  韦尼克智能创作平台资源计费说明
                </div>
                <div>支持企业级定制需求，详情请联系客服</div>
              </div>
              <div className="billing-table">
                <div className="table-th table-head rowStart">
                  {this.setObject(data.heads).map((item, key) => {
                    return (
                      <div
                        className="table-td rowCenter"
                        key={key}
                        style={{ '--width': data.heads[item].width }}
                      >
                        {item}
                      </div>
                    )
                  })}
                </div>
                <div className="table-bodys">
                  {/* 原有表头分割线逻辑（完全保留，未修改） */}
                  {this.setObject(data.heads).map((item, key) => {
                    widthleft += parseInt(data.heads[item].width)
                    return (
                      <div
                        className="table-hr"
                        key={key}
                        style={{ '--left': widthleft + '%' }}
                      ></div>
                    )
                  })}

                  {/* 原有表格主体外层循环（添加了下边框样式） */}
                  {data.bodys.map((item, key) => {
                    let id = 'th_id' + key
                    // 判断是否为最后一个产品行
                    const isLastItem = key === data.bodys.length - 1
                    return (
                      <div
                        className="table-th rowStart"
                        key={key}
                        id={id}
                        // 为非最后一个产品行添加下边框加粗样式
                        style={{
                          borderBottom: isLastItem
                            ? 'none'
                            : '2px solid #bedcff'
                        }}
                      >
                        {/* 原有产品列（完全保留，未修改） */}
                        <div
                          className="table-td columnCenter"
                          style={{
                            '--width':
                              data.heads[this.setObject(data.heads)[0]].width
                          }}
                        >
                          <div
                            className="table-td-full columnCenter"
                            style={{
                              '--background': this.setbackground('#FAFAFA'),
                              '--width':
                                data.heads[this.setObject(data.heads)[0]].width
                            }}
                          >
                            {item.type}
                          </div>
                        </div>

                        {/* 原有中间列（服务项+说明+费用，完全保留结构，未修改） */}
                        <div
                          className="table-td"
                          style={{
                            '--width':
                              parseInt(
                                data.heads[this.setObject(data.heads)[1]].width
                              ) +
                              parseInt(
                                data.heads[this.setObject(data.heads)[2]].width
                              ) +
                              parseInt(
                                data.heads[this.setObject(data.heads)[3]].width
                              ) +
                              '%'
                          }}
                        >
                          {item.payservice.map((item2, key2) => {
                            let ids = id + key2
                            return (
                              <div
                                className="table-th rowCenter"
                                key={key2}
                                id={ids}
                              >
                                <div
                                  className="table-td"
                                  style={{
                                    '--width': '50%',
                                    position: 'relative'
                                  }}
                                >
                                  <div
                                    className="table-th"
                                    key={key2}
                                    style={{
                                      marginLeft: '40%'
                                    }}
                                  >
                                    {item2.function.map((item3, index) => {
                                      return (
                                        <div
                                          className="table-th columnCenter"
                                          key={index}
                                          style={{
                                            width: '60%'
                                          }}
                                        >
                                          <div>{item3}</div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                  <div
                                    className="table-th table-product"
                                    style={{
                                      height: item2.metering.length * 58 + 'px'
                                    }}
                                  >
                                    {item2.title}
                                  </div>
                                </div>

                                <div
                                  className="table-td"
                                  style={{
                                    '--width': '70%'
                                  }}
                                >
                                  <div className="table-th">
                                    {item2.metering.map((item3, index) => {
                                      return (
                                        <div
                                          className="table-th columnCenter"
                                          key={index}
                                        >
                                          <div
                                            style={{
                                              width: '95%'
                                            }}
                                          >
                                            {item3}
                                          </div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                                <div
                                  className="table-td"
                                  style={{
                                    '--width': '20%'
                                  }}
                                >
                                  <div className="table-th" key={key2}>
                                    {item2.moneys.map((item3, index) => {
                                      return (
                                        <div
                                          className="table-th columnCenter"
                                          key={index}
                                        >
                                          <div>{item3}</div>
                                        </div>
                                      )
                                    })}
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </div>

                        {/* 资费说明列（完全保留，未修改） */}
                        <div
                          className="table-td"
                          style={{
                            '--width':
                              data.heads[this.setObject(data.heads)[4]].width
                          }}
                        >
                          {/* 核心逻辑：判断外层是否有moneysMetering，有则用原有统一内容，无则按服务项渲染discount */}
                          {item.moneysMetering?.trim() ? (
                            // 原有逻辑：外层有moneysMetering，统一渲染一次
                            <div className="table-th" key={key}>
                              <div
                                className="table-th columnCenter"
                                style={{
                                  textAlign: 'left'
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: item.moneysMetering
                                  }}
                                ></div>
                              </div>
                            </div>
                          ) : (
                            // 新增逻辑：外层无moneysMetering，按每个服务项渲染对应discount
                            <div className="table-th" key={key}>
                              {item.payservice.map((item2, key2) => (
                                <div
                                  className="table-th columnCenter"
                                  key={key2}
                                  // 保持与中间服务项行高一致（按metering长度计算，与原有行高逻辑匹配）
                                  style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    height: `${item2.metering.length * 57}px`,
                                    display: 'flex',
                                    alignItems: 'center', // 垂直居中对齐
                                    fontSize: '14px'
                                  }}
                                >
                                  <div
                                    style={{
                                      padding: '0 10px'
                                    }}
                                    dangerouslySetInnerHTML={{
                                      __html: item2.discount || '' // 无discount则显示空
                                    }}
                                  ></div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    )
  }
}
export default Billingmethod
